import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { firstImportJobsPageQueryOptions } from '~/modules/contract/import/contractImportJobsQueries';
import { ContractsList } from '~/modules/contract/list';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from './-routeParams';
import {
  contractsSearchDefaults,
  zodContractsSearchSchema,
} from './-searchParams';

const title = i18n.t(($) => $.listPageTitle, { ns: 'contract' });

export const Route = createFileRoute('/(main)/demand/contracts/')({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/contracts/',
    ...routeParams,
  }),
  component: ContractsList,
  head: () => getRouteHead(title, 'Verwalte deine Aufträge in VESTIGAS'),
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(firstImportJobsPageQueryOptions);
  },
  search: {
    middlewares: [stripSearchParams(contractsSearchDefaults)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodContractsSearchSchema,
});

export const DEMAND_CONTRACTS = buildRouteExport({
  Route,
  ...routeParams,
});
